export enum ComponentType {
  SUBJECT = 'SUBJECT',
  BODY = 'BODY'
}
